import React, { useEffect, useRef } from 'react';
interface WelcomePageProps {
  onGoToLogin: () => void;
  onGoToRegister: () => void;
}
export function WelcomePage({
  onGoToLogin,
  onGoToRegister
}: WelcomePageProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.play().catch(() => {});
    }
  }, []);
  return <div className="min-h-screen flex flex-col relative overflow-hidden" data-id="element-1216">
      {/* Video Background */}
      <video ref={videoRef} autoPlay muted loop playsInline preload="auto" className="absolute inset-0 w-full h-full object-cover z-0" data-id="element-1217">
        <source src="https://videos.pexels.com/video-files/7218807/7218807-hd_1080_1920_25fps.mp4" type="video/mp4" data-id="element-1218" />
        <source src="https://videos.pexels.com/video-files/7218807/7218807-sd_506_960_25fps.mp4" type="video/mp4" data-id="element-1219" />
      </video>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/50 z-[1]" data-id="element-1220" />

      {/* Content */}
      <div className="relative z-10 flex flex-col flex-1 px-6" data-id="element-1221">
        {/* Top: Logo + Tagline - In alto */}
        <div className="flex-1 flex flex-col items-center justify-start pt-16" data-id="element-1222">
          <img src="https://cdn.magicpatterns.com/uploads/bgucnc6iAv4SE4noNyVpoM/Logo_esteso.svg" alt="Yeppy" className="h-8 w-auto mb-6 drop-shadow-lg brightness-0 invert" data-id="element-1223" />

          <p className="font-poppins text-base text-white text-center max-w-[280px] leading-relaxed" data-id="element-1224">
            Organizza, ricorda e condividi tutto ciò che conta per i tuoi figli.
          </p>
        </div>

        {/* Bottom: Buttons + Disclaimer */}
        <div className="pb-10 space-y-3" data-id="element-1225">
          {/* Login Button - Primary, dark blue solid */}
          <button onClick={onGoToLogin} className="w-full py-3 rounded-xl font-poppins text-sm font-semibold" style={{
          backgroundColor: '#1D2A36',
          color: '#FFFFFB'
        }} data-id="element-1226">
            Accedi
          </button>

          {/* Register Button - Secondary, solid white */}
          <button onClick={onGoToRegister} className="w-full py-3 rounded-xl font-poppins text-sm font-semibold" style={{
          backgroundColor: '#FFFFFB',
          color: '#1D2A36'
        }} data-id="element-1227">
            Registrati
          </button>

          {/* Disclaimer */}
          <p className="font-poppins text-xs text-white text-opacity-50 text-center leading-relaxed pt-2" data-id="element-1228">
            Continuando, accetti i nostri{' '}
            <button className="underline text-white text-opacity-60 transition-opacity" data-id="element-1229">
              Termini e Condizioni
            </button>{' '}
            e la{' '}
            <button className="underline text-white text-opacity-60 transition-opacity" data-id="element-1230">
              Privacy Policy
            </button>
          </p>
        </div>
      </div>
    </div>;
}